import { AxiosResponse } from "axios";

import axiosInstance from "../axios_instance";
import * as models from "./models";

export async function deployFlow(flowInput: models.FlowInput): Promise<AxiosResponse<models.FlowOutput>> {
    const response = await axiosInstance.post<models.FlowInput, AxiosResponse<models.FlowOutput>>(
      `/v1/experiments/flows`,
      flowInput,
    );
    return response;
}
